import { useState } from "react";
import DeviceList from "./components/list";
import { Breadcrumbs } from "../../../components/Common";
import DeviceFormModal from "./components/form/index";

const MyDevicesPage = () => {
    const [showDeviceForm, setShowDeviceForm] = useState(false);
    return (
        <>
            <Breadcrumbs
                title="My Machines"
            >
                <button
                    className="ms-4 btn btn-primary"
                    onClick={() => setShowDeviceForm(true)}
                >
                    REGISTER MACHINE
                </button>
            </Breadcrumbs>

            <DeviceList />
            <DeviceFormModal
                isOpen={showDeviceForm}
                onClose={() => setShowDeviceForm(false)}
            />
        </>
    );
};

export default MyDevicesPage;
